import { DefaultState } from '@src/redux/types'

import * as TYPES from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [TYPES.TIMETABLE]: DefaultState<`${typeof API.TIMETABLE}`, 'get'>
  [TYPES.TIMETABLE_ALL]: DefaultState<`${typeof API.TIMETABLE_ALL}`, 'get'>
} = () => ({
  [TYPES.TIMETABLE]: defaultState(),
  [TYPES.TIMETABLE_ALL]: defaultState(),
})
